import { UserFilters } from '../../types/UserFilters';
import { useGetReport } from '../base/useGetReport';

export const useGetUsersOfResourceReport = (userId: string, filters: UserFilters) => {
    const { downloadReport, downloadingReport } = useGetReport<UserFilters>(`resources/${userId}/users`, filters);

    return {
        downloadReport,
        downloadingReport
    };
};
